export const PORTAL_NEGOTIATION_LINK = 'https://portal-gigamaisfibra.sydle.com/devolucao-de-credito'
